import { IDetailedOrderStatusRequestService } from "../IDetailedOrderStatusRequestService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export abstract class DetailedOrderStatusRequestPromiseService
  implements IDetailedOrderStatusRequestService
{
  abstract request(id: String): Promise<CubiqTS.OrderDataImpl>;

  abstract requestMediatedOrderDetails(id: String): Promise<any>;

  /**
   * Return trade deals for multiple orders - mutliple is useful for strategies and Gammas
   *
   * @param ids
   * @returns
   */
  abstract requestAdaptedTradeDeals(ids: Array<string>): Promise<any>;

  abstract releaseMediatedOrderDetails(requestRef: String): Promise<void>;

  abstract getMediatedOrderData(
    orderId: string,
    requestRef: string | null,
  ): Promise<CubiqTS.OrderDataImpl>;
}
